import { Expose } from 'class-transformer';
import { Model } from './model';
import { TotalWithRate } from '../../interface';

export class WhiteLabelTotalSessions extends Model {
  @Expose() benficiaryData: TotalWithRate;
  @Expose() sessionData: TotalWithRate;
  @Expose() pagesData: TotalWithRate;
  @Expose() minutesData: TotalWithRate;
  @Expose() lettersData: TotalWithRate;
}
